import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import styled from "@emotion/styled";
import tw from "twin.macro";

import PortableText from "./portableText";
// import Newsletter from "../Form/Newsletter";
import CallToAction from "../Repeating/CTA";
import ButtonSolid from "../Button/ButtonSolid";

const StyledContent = styled.div`
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  span,
  li {
    ${tw`text-white`}
  }
  p {
    ${tw`mb-4 text-white`}
  }
  ul {
    ${tw`list-disc pl-7 mb-4 flex flex-col space-y-0.5 text-white`}
  }
  ol {
    ${tw`list-decimal pl-7 mb-6 flex flex-col space-y-0.5 text-white`}
  }
  a {
    ${tw`text-primary-600 `}
  }
`;

function Position(props) {
  const { siteMetadata, slug, textBlocks, title, publishedAt } = props;

  const data = useStaticQuery(graphql`
    {
      posts: allSanityPost(
        sort: { fields: [publishedAt], order: DESC }
        filter: { slug: { current: { ne: null } }, publishedAt: { ne: null } }
      ) {
        edges {
          node {
            id
            publishedAt
            featuredImage {
              asset {
                gatsbyImageData
              }
            }
            categories {
              _id
              title
            }
            title
            slug {
              current
            }
          }
        }
      }
    }
  `);

  return (
    <>
      <div className="container">
        <article className="pt-12 md:pt-20 pb-20 md:pb-32  px-6 md:px-14 lg:px-22">
          <header className="md:text-start">
            <h1 className="text-white heading-two">{title}</h1>
          </header>

          {/* <div className="flex justify-between items-end mb-8 md:mb-10">
            <div className="flex">
              <div>
                {publishedAt && (
                  <div className="text-sm text-white font-normal">
                    {differenceInDays(new Date(publishedAt), new Date()) > 3
                      ? formatDistance(new Date(publishedAt), new Date())
                      : format(new Date(publishedAt), "MMMM d, yyyy")}
                  </div>
                )}
              </div>
            </div>
          </div> */}
          <div>
            {textBlocks.map((block, index) => (
              <div
                key={index}
                className={`flex flex-col gap-y-6  border-primary-600 py-10 ${
                  index == textBlocks.length - 1 ? "border-b-[0px]" : "border-b-[1px]"
                }`}
              >
                <div className="text-white font-heading text-[24px] font-bold leading-[34px]">
                  {block.blockTitle}
                </div>
                <StyledContent>
                  {block._rawBlockText && <PortableText blocks={block._rawBlockText} />}
                </StyledContent>
              </div>
            ))}
            <ButtonSolid
              modal="modal-contact"
              altStyle={2}
              text="Apply"
              className="w-full md:w-auto !bg-primary-600 !text-white"
            />
          </div>
        </article>
      </div>

      <CallToAction />
    </>
  );
}

export default Position;
